module.exports = __webpack_public_path__ + "1c3fe5479eb0b033113335de36877f7f.fbx";